import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'main' }
    }, {
      path: '/main',
      name: 'main',
      redirect: { name: 'index' }
    }, {
      path: '/payment/:type/:method/:token',
      name: 'payment',
      component: (resolve) => {
        require(['../pages/main/payment.vue'], resolve)
      }
    }, {
      path: '/index',
      name: 'index',
      component: (resolve) => {
        require(['../pages/index.vue'], resolve)
      }
    }, {
      path: '*',
      redirect: { name: 'main' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js